import Marquee from "react-fast-marquee";
import { Asterisk } from "lucide-react";
import { MARQUEE_WORDS } from "@/data/content";
import { useLang } from "@/i18n/LanguageContext";

const EditorialMarquee = ({ dark = true }) => {
  const { t } = useLang();
  const words = [t("mq1"), t("mq2"), t("mq3"), t("mq4"), t("mq5"), t("mq6")];
  return (
  <div
    data-testid="editorial-marquee"
    className={`py-8 lg:py-10 overflow-hidden ${
      dark ? "bg-pine-950 text-bone" : "bg-white text-pine-950 border-y border-mist"
    }`}
  >
    <Marquee speed={35} gradient={false} pauseOnHover>
      {words.map((word) => (
        <span key={word} className="flex items-center">
          <span className="font-serif italic font-light text-3xl lg:text-5xl tracking-tight px-8 lg:px-12">
            {word}
          </span>
          <Asterisk size={28} className={dark ? "text-pine-500" : "text-pine-400"} />
        </span>
      ))}
    </Marquee>
  </div>
  );
};

export default EditorialMarquee;
